import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import ShilpFooterLogo from '../../img/Shilp-Footer-Logo.webp';
import LinkedInLogo from '../../img/Icons/Social-Icons/LinkedIn.webp';
import XLogo from '../../img/Icons/Social-Icons/Twitter.webp';
import InstagramLogo from '../../img/Icons/Social-Icons/Instagram.webp';
import './Footer.css';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [showPopup, setShowPopup] = useState(false);
  const [messageColor, setMessageColor] = useState('#9A28CA');

  useEffect(() => {
    if (showPopup) {
      const timer = setTimeout(() => {
        setShowPopup(false);
        setMessage('');
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [showPopup]);

  const handleSubscribe = async () => {
    if (!email) {
      setMessage('Please enter an email address.');
      setMessageColor('#9A28CA');
      setShowPopup(true);
      return;
    }
    try {
      const response = await fetch('https://devapirecruitpro.shilp.ai/subscriptions/subscribe', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });
      const data = await response.json();
      if (response.ok) {
        setMessage('Subscription successful!');
        setMessageColor('#9A28CA');
        setEmail('');
        setShowPopup(true);
      } else if (response.status === 409 || (data && data.message && data.message.toLowerCase().includes('already subscribed'))) {
        setMessage('You have already subscribed.');
        setMessageColor('#9A28CA');
        setShowPopup(true);
      } else {
        setMessage('Please enter a valid email address.');
        setMessageColor('#9A28CA');
        setShowPopup(true);
      }
    } catch (error) {
      setMessage('An error occurred. Please try again later.');
      setMessageColor('#9A28CA');
      setShowPopup(true);
      console.error('Subscribe error:', error);
    }
  };

  return (
    <footer className="secondary-footer">
      <div className="secondary-footer-top">
        <div className="footer-column">
          <img
            src={ShilpFooterLogo}
            alt="SHILP ai company logo"
            title="SHILP ai company logo"
            width="141"
            height="60"
            className="footer-logo"
          />
        </div>

        <div className="footer-column">
          <h4>About</h4>
          <ul>
            <li><Link to="/about-us">About Us</Link></li>
            <li><Link to="/leadership">Leadership</Link></li>
            <li><Link to="/responsible-ai">Responsible AI</Link></li>
            <li><Link to="/privacy-policy">Privacy Policy</Link></li>
            <li><Link to="/terms-of-use">Terms of Use</Link></li>
            <li><Link to="/cookie-policy">Cookie Policy</Link></li>
          </ul>
        </div>

        <div className="footer-column">
          <h4>Resources</h4>
          <ul>
            <li><Link to="/blog-case-studies">Blog / Case Studies</Link></li>
            <li><Link to="/webinars-events">Webinars & Events</Link></li>
            <li><Link to="/product-docs">Product Docs</Link></li>
            <li><Link to="/api-access">API Access</Link></li>
            <li>
              <a href="https://www.shilp.ai/quick-start.html" target="_blank" rel="noopener noreferrer">
                Quick Start Guide for Job Seekers
              </a>
            </li>
            <li>
              <a href="https://www.shilp.ai/quick_start_Guide_for_employers.html" target="_blank" rel="noopener noreferrer">
                Quick Start Guide for Employers
              </a>
            </li>
          <li><Link to="/jobseekers-govcon">GovCon Career Guides (Job Seekers)</Link></li>
          <li><Link to="/recruiter/Employersgovcon">GovCon Hiring & Compliance (Employers)</Link></li>
          </ul>
        </div>

        <div className="footer-column">
          <h4>Contact</h4>
          <ul>
            <li><Link to="/contact-location">Contact & Location</Link></li>
            <li>
              <a href="https://www.shilp.ai/product-demo.html" target="_blank" rel="noopener noreferrer">
                Request a Demo
              </a>
            </li>
          </ul>
          <h4 className="get-started-heading">Get Started</h4>
          <ul>
            <li>
              <a href="https://www.shilp.ai/SHILP_free_trial.html" target="_blank" rel="noopener noreferrer">
                Start Free Trial RecruitPro
              </a>
            </li>
            <li>
              <a href="https://www.shilp.ai/ai-for-recruitpro-access.html" target="_blank" rel="noopener noreferrer">
                Request Enterprise-AI Access
              </a>
            </li>
          </ul>
        </div>

        <div className="footer-column subscription-column">
          <h4>Get job notifications</h4>
          <p className="subscription-info-text">
            Latest job news and articles will be sent to your e-mail.
          </p>
          <div className="subscription-form-container">
            <h4>Email</h4>
            <div className="subscription-form">
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                aria-label="Email for subscription"
              />
              <button onClick={handleSubscribe}>Subscribe</button>
            </div>
            {showPopup && (
              <p style={{ color: messageColor }}>{message}</p>
            )}
          </div>
        </div>
      </div>

      <div className="secondary-footer-bottom">
        <p>
          Powered by <a href="https://www.shilp.ai" target="_blank" rel="noopener noreferrer"><strong>SHILP.ai</strong></a> 
          {' '}| © 2025 <a href="https://www.globaldatasolutions.com" target="_blank" rel="noopener noreferrer"><strong>Global Data Solutions Inc.</strong></a> 
          {' '}All Rights Reserved.
        </p>
        <a href="https://www.shilp.ai/equal-opportunity-employer.html" target="_blank" rel="noopener noreferrer">
          Equal Employment Opportunity
        </a>
        <div className="social-icons">
          <a href="https://www.linkedin.com/in/shilp-ai-b120b5366/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
            <img src={LinkedInLogo} alt="LinkedIn" width="35" height="35" />
          </a>
          <a href="https://x.com/AiShilp" target="_blank" rel="noopener noreferrer" aria-label="X">
            <img src={XLogo} alt="X" width="35" height="35" />
          </a>
          <a href="https://www.instagram.com/shilp.ai_1/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
            <img src={InstagramLogo} alt="Instagram" width="35" height="35" />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
